'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { connect } from 'starknetkit';
import { WebWalletConnector } from 'starknetkit/webwallet';
import { RpcProvider } from 'starknet';
import { logger } from '@dynamic-labs/wallet-connector-core';
import ArgentXBase from './argentxBase.js';

class ArgentXWeb extends ArgentXBase {
    constructor(opts) {
        super('Argent X - Web', 'argentWebWallet', opts);
        this.overrideKey = 'argentxweb';
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const nodeUrl = this.getSelectedNodeUrl();
                const wallet = yield this.getWallet();
                if (wallet && wallet.isConnected) {
                    return;
                }
                else {
                    const connection = yield connect({
                        connectors: [
                            new WebWalletConnector({
                                provider: new RpcProvider({
                                    nodeUrl,
                                }),
                                url: 'https://web.argent.xyz',
                            }),
                        ],
                    });
                    if (connection && connection.wallet && connection.wallet.isConnected) {
                        this.wallet = connection.wallet;
                    }
                }
            }
            catch (err) {
                logger.error('Error establishing connection to Argent Web Wallet', err);
            }
        });
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.getAddress();
            if (!address)
                return [];
            return [address];
        });
    }
}

export { ArgentXWeb };
